module.exports = __webpack_public_path__ + "img/share_word_fuxing.501bb980.png";